export default {
	ASCENDING: 'ascending',
	DESCENDING: 'descending',
};
